module.exports = __webpack_public_path__ + "img/versionInfoNew.637d1fc0.svg";